import { useTranslation } from 'react-i18next';
import {
  Stack,
  Typography,
  Box,
  Drawer,
  IconButton,
  Button,
  Dialog,
  Grid,
} from '@mui/material';
import Iconify from '../../components/Iconify';
import useMobile from '../../hooks/useMobile';
import { useModals } from '@mattjennings/react-modal-stack';

function RemoveProtectionDialog({ open, data }) {
  const { t } = useTranslation();
  const { isMobile } = useMobile();
  const { closeModal } = useModals();

  const Component = isMobile ? Drawer : Dialog;

  const handleClick = () => {
    closeModal();
  };

  return (
    <Component
      anchor="bottom"
      open={open}
      onClose={() => {
        closeModal();
      }}
    >
      <Box sx={{ width: '100%', height: '100%', padding: '32px' }}>
        <Stack
          direction="row"
          sx={{
            mb: '8px',
          }}
        >
          <Box sx={{ minWidth: 160 }}>
            <Typography variant="subtitle1" sx={{}}>
              Protección no disponible
            </Typography>
          </Box>
          <Box sx={{ flexGrow: 1 }}></Box>
          <IconButton sx={{ mt: -0.8 }} onClick={() => handleClick()}>
            <Iconify
              sx={{ color: 'black' }}
              width={20}
              height={20}
              icon={'material-symbols:close'}
            />
          </IconButton>
        </Stack>
        <Box
          sx={{
            'width': '100%',
            '& form': {
              width: '100%',
            },
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body2" color="grey.600">
                La opción de protección para tus boletos ya no está disponible
                para esta compra. No te preocupes,
                <Typography
                  component="span"
                  variant="body2"
                  color="black"
                  sx={{ fontWeight: '500' }}
                >
                  {' '}
                  hemos removido el cargo correspondiente a la protección{' '}
                </Typography>{' '}
                y puedes continuar con tu compra con total tranquilidad.
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              <Button type="submit" variant="contained" onClick={handleClick}>
                Seguir comprando
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Component>
  );
}

export default RemoveProtectionDialog;
